<spike-base-page [breadcrumbItems]="breadcrumb" [title]="title()">
    
    <div actions>
        <p-button (click)="openWalletDialog()" label="Aggiungi" icon="pi pi-plus"></p-button>
    </div>

   
    @if (walletRecapResource.hasValue() && walletRecapResource.value().length > 0) {
        <div class="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
            <div class="spike-card">
                <spike-wallet-recap [wallets] ="wallets()" (onSelect)="openWalletDialog($event.finWalletId)"></spike-wallet-recap>
            </div>
            <div class="spike-card">
                <spike-wallet-pie-chart [walletRecap]="wallets()"></spike-wallet-pie-chart>
            </div>
        </div>      
    }
    @else{
        <spike-no-result 
            title="Nessun wallet trovato"
            description="Non hai ancora aggiunto wallet. Clicca sul bottone per crearne uno." 
            icon="account_balance_wallet">
            <button pButton (click)="openWalletDialog()" label="Crea" icon="pi pi-plus"></button>
        </spike-no-result>
    } 

</spike-base-page>
@if(isSidepanelVisibile()){
    <spike-wallet-side-panel 
        [(isDialogVisible)]="isSidepanelVisibile"
        [data]="selectedWallet()"
        (onSave)="onSave()"
        (onClose)="closeSidePanel()"
        (onDelete)="onDelete()"/>
}
